module.exports = __webpack_public_path__ + "static/media/app-produtos.89dabcc5.png";